import React, {useEffect, useState} from "react";
import axios from "axios";
import {getInfoText} from "../../libs/text";

const Form = (props) => {
    const [form, setForm]  = useState({
        anrede: {
            value:'',
            validation: 'required',
            error: false
        },
        nachname: {
            value:'',
            validation: 'required',
            error: false
        },
        vorname: {
            value:'',
            validation: 'required',
            error: false
        },
        strasse: {
            value:'',
            validation: 'required',
            error: false
        },
        hausnummer: {
            value:'',
            validation: 'required',
            error: false
        },
        plz: {
            value:'',
            validation: 'required,plz',
            error: false
        },
        ort: {
            value:'',
            validation: 'required',
            error: false
        },
        email: {
            value:'',
            validation: 'required,email',
            error: false
        },
        phone: {
            value:'',
            error: false
        },
        text: {
            value:'',
            validation: 'required',
            error: false
        },
        info: {
            value:true,
            error: false
        },
        products: {
            value:false,
            error: false
        },
        datenschutz: {
            value:false,
            validation: 'required',
            error: false
        },
        availability: {
            value: props.searchObject.availability
        }
    })

    const [text, setText]  = useState(<></>);

    useEffect(() => {
        setForm((prevState) => {
            prevState.strasse.value = props.searchObject.strasse;
            prevState.hausnummer.value = props.searchObject.hsnr;
            prevState.plz.value = props.searchObject.plz;
            prevState.ort.value = props.searchObject.stadt;
            return({
                ...prevState
            })
        });

        setText(getInfoText(props));
    },[props.searchObject]);

    // Validate the form for simple mistakes
    const validateAndSendForm = () => {
        const formData = new FormData();

        let error = false;

        //check for every required field if value is set
        for (const [key, value] of Object.entries(form)) {
            if(value.validation) {
                value.validation.split(",").forEach((validation)=>{
                    if(!validationCheck(validation,value.value)) {
                        error=true;

                        setForm((prevState) => {
                            prevState[key].error = true;
                            return({
                                ...prevState
                            })
                        })
                    } else {
                        setForm((prevState) => {
                            prevState[key].error = false;
                            return({
                                ...prevState
                            })
                        })

                        formData.append(`formData[${key}]`, value.value);
                    }
                });
            }
            else {
                setForm((prevState) => {
                    prevState[key].error = false;
                    return({
                        ...prevState
                    })
                })

                formData.append(`formData[${key}]`, value.value);
            }
        }

        // Check, if we should proceed the form - or not
        if (!error) {
            const options = {
                method: 'POST',
                url: new URL(document.location).toString(),
                params: {type: '12345'},
                headers: {
                    'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'
                },
                data: formData
            };

            axios.request(options)
                .then((response)=>{
                    props.setFinished(true);
                })
                .catch(function () {
                    props.setSearchObject({availability:-1})
                });
        }
    }

    const validationCheck = (validation,value) => {
        switch (validation) {
            case 'required': {
                if(!value) {
                    return false;
                }
                break;
            }
            case 'plz': {
                if (!(value.match(/^[0-9]{5}$/))) {
                    return false;
                }
                break;
            }
            case 'email': {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(value);
            }
        }

        return true;
    }

    return <section id="verfuegbar" className="bg-lightgreen availability-check-result">
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    {text}
                    {props.searchObject.availability>0 ?
                        <div className="formee">
                            <form>
                                <fieldset>
                                    <legend>Ihre Daten</legend>
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <div className={`form-group ${form.anrede.error?'error':''}`}>
                                                <label htmlFor="anrede">Anrede*</label>
                                                <select
                                                    onChange={(e) => setForm((prevState) => {
                                                            prevState.anrede.value = e.target.value;
                                                                return({
                                                                    ...prevState
                                                                })
                                                            })}
                                                    className="form-control"
                                                    name="anrede"
                                                >
                                                    <option value="keineAnrede">Keine Anrede</option>
                                                    <option value="Herr">Herr</option>
                                                    <option value="Frau">Frau</option>
                                                    <option value="Eheleute">Eheleute</option>
                                                    <option value="Wohngemeinschaft">Wohngemeinschaft</option>
                                                    <option value="Erbengemeinschaft">Erbengemeinschaft</option>
                                                    <option value="Eigentuemergemeinschaft">Eigentümergemeinschaft</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className={`form-group ${form.nachname.error?'error':''}`}>
                                                <label htmlFor="name">Name*</label>
                                                <input
                                                    onChange={(e) => setForm((prevState) => {
                                                        prevState.nachname.value = e.target.value;
                                                        return({
                                                            ...prevState
                                                        })
                                                    })}
                                                    className="form-control uoValidateOnSubmit validateEmpty"
                                                    type="text"
                                                    name="name"
                                                    value={form.nachname.value||''}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className={`form-group ${form.vorname.error?'error':''}`}>
                                                <label htmlFor="vorname">Vorname*</label>
                                                <input
                                                    onChange={(e) => setForm((prevState) => {
                                                        prevState.vorname.value = e.target.value;
                                                        return({
                                                            ...prevState
                                                        })
                                                    })}
                                                    className="form-control uoValidateOnSubmit validateEmpty"
                                                    type="text" name="vorname"
                                                    value={form.vorname.value||''}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-10">
                                            <div className={`form-group ${form.strasse.error?'error':''}`}>
                                                <label htmlFor="street">Straße*</label>
                                                <input
                                                    value={form.strasse.value||''}
                                                    className="form-control uoValidateOnSubmit validateEmpty"
                                                    type="text"
                                                    name="street"
                                                    readOnly="true"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <div className={`form-group ${form.hausnummer.error?'error':''}`}>
                                                <label htmlFor="housenumber">Hausnr.*</label>
                                                <input
                                                    value={form.hausnummer.value||''}
                                                    className="form-control uoValidateOnSubmit validateEmpty"
                                                    type="text"
                                                    name="housenumber"
                                                    readOnly="true"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <div className={`form-group ${form.plz.error?'error':''}`}>
                                                <label htmlFor="plz">PLZ*</label>
                                                <input
                                                    className="form-control uoValidateOnSubmit validateEmpty validatePLZ"
                                                    type="tel"
                                                    name="plz"
                                                    value={form.plz.value||''}
                                                    readOnly="true"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-9">
                                            <div className={`form-group ${form.ort.error?'error':''}`}>
                                                <label htmlFor="town">Wohnort*</label>
                                                <input
                                                    className="form-control uoValidateOnSubmit validateEmpty"
                                                    type="text"
                                                    name="town"
                                                    value={form.ort.value||''}
                                                    readOnly="true"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className={`form-group ${form.email.error?'error':''}`}>
                                                <label htmlFor="email">E-Mail*</label>
                                                <input
                                                    onChange={(e) => setForm((prevState) => {
                                                        prevState.email.value = e.target.value;
                                                        return({
                                                            ...prevState
                                                        })
                                                    })}
                                                    className="form-control uoValidateOnSubmit validateEmpty validateEMail"
                                                    type="email"
                                                    name="email"
                                                    value={form.email.value||''}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className={`form-group ${form.phone.error?'error':''}`}>
                                                <label htmlFor="phone">Telefon</label>
                                                <input
                                                    onChange={(e) => setForm((prevState) => {
                                                        prevState.phone.value = e.target.value;
                                                        return({
                                                            ...prevState
                                                        })
                                                    })}
                                                    className="form-control"
                                                    type="tel"
                                                    name="phone"
                                                    value={form.phone.value||''}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className={`form-group ${form.text.error?'error':''}`}>
                                                <label htmlFor="anliegen">Ihr Anliegen*</label>
                                                <textarea
                                                    onChange={(e) => setForm((prevState) => {
                                                        prevState.text.value = e.target.value;
                                                        return({
                                                            ...prevState
                                                        })
                                                    })}
                                                    rows="10"
                                                    className="form-control uoValidateOnSubmit validateEmpty"
                                                    name="anliegen"
                                                    value={form.text.value||''}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {props.searchObject.availability === 5 ?
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className={`form-group ${form.info.error?'error':''}`}>
                                                    <div className="checkbox">
                                                        <label className="checkbox-inline" htmlFor="info"
                                                               onClick={(e) => setForm((prevState) => {
                                                                   prevState.info.value = !prevState.info.value;
                                                                   return({
                                                                       ...prevState
                                                                   })
                                                               })}>
                                                            <div className={`icheckbox_flat-grey ${form.info.value?'checked':''}`}/>&nbsp;
                                                            <span>Ich möchte per E-Mail über den Ausbaustatus des Projektes auf dem Laufenden gehalten werden.</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>:
                                        null
                                    }
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className={`form-group ${form.datenschutz.error?'error':''}`}>
                                                <div className="checkbox">
                                                    <label className="checkbox-inline" htmlFor="datenschutz"
                                                           onClick={(e) => setForm((prevState) => {
                                                                prevState.datenschutz.value = !prevState.datenschutz.value;
                                                                return({
                                                                    ...prevState
                                                                })
                                                           })}>
                                                        <div className={`icheckbox_flat-grey ${form.datenschutz.value?'checked':''}`}/>&nbsp;
                                                        <span>Ich bestätige die Kenntnisnahme der <a href="/footer-links/datenschutz" title="Datenschutzbestimmungen" target="_blank">Datenschutzbestimmungen</a>.*</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className={`form-group ${form.products.error?'error':''}`}>
                                                <div className="checkbox">
                                                    <label className="checkbox-inline" htmlFor="products"
                                                           onClick={(e) => setForm((prevState) => {
                                                               prevState.products.value = !prevState.products.value;
                                                               return({
                                                                   ...prevState
                                                               })
                                                           })}>
                                                        <div className={`icheckbox_flat-grey ${form.products.value?'checked':''}`}/>&nbsp;
                                                        <span>
				                                            Ich willige ein, dass mich die Stadtwerke Hamm GmbH telefonisch sowie per E-Mail über eigene Produkte und Dienstleistungen sowie Produkte und Dienstleistungen ihrer Tochtergesellschaften informieren sowie zum Zweck der Markt- und Meinungsforschung kontaktieren darf. Meine Einwilligung kann ich jederzeit ganz oder teilweise gegenüber der Stadtwerke Hamm GmbH für die Zukunft widerrufen, ohne dass mir hierfür andere als die Porto- bzw. Übermittlungskosten nach den Basistarifen entstehen; ohne meine Einwilligung bestehende Werbemöglichkeiten bleiben hiervon - soweit vom Widerruf nicht ausdrücklich erfasst - unberührt.
				                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p className="pflichtfeld">* Pflichtfeld</p>
                                    <div className="buttons">
                                        <button type="button" className="btn btn-default" title="" onClick={()=>validateAndSendForm()}>Absenden</button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>:null
                    }
                </div>
            </div>
        </div>
    </section>
}

export default Form;
